/* Verzendetiket.nl: bolletjes onder de mobiele sliders (.ve-slider). */
(function () {
  'use strict';
  function init(scope) {
    var sliders = (scope || document).querySelectorAll('.ve-slider:not([data-ve-dots])');
    Array.prototype.forEach.call(sliders, function (s) {
      s.setAttribute('data-ve-dots', '');
      var n = s.children.length;
      if (n < 2) return;
      var dots = document.createElement('div');
      dots.className = 've-dots';
      dots.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < n; i++) dots.appendChild(document.createElement('span'));
      s.parentNode.insertBefore(dots, s.nextSibling);
      var bezig = false;
      function update() {
        bezig = false;
        var eerste = s.firstElementChild;
        if (!eerste) return;
        var stap = eerste.getBoundingClientRect().width + parseFloat(getComputedStyle(s).columnGap || 12);
        var max = s.scrollWidth - s.clientWidth;
        var actief = s.scrollLeft >= max - 4 ? n - 1 : Math.round(s.scrollLeft / stap);
        Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-actief', j === actief); });
      }
      s.addEventListener('scroll', function () { if (!bezig) { bezig = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();